import { Action } from "@ngrx/store";
import { ReduxAction } from "./../actions/redux.action";
import { Patient } from "../models";

export function PatientReducer(state: Patient, action: ReduxAction) {
  switch (action.type) {
    case "SET_PATIENT_PROFILE":
      return Object.assign({}, state, action.get());

    case "SET_PATIENT_BILLING":
      return Object.assign({}, state, action.get());

    case "SET_PATIENT_PHYSICIAN":
      return Object.assign({}, state, action.get());

    case "SET_FULL_PATIENT":
      return Object.assign({}, state, action.get());

    case "SET_NEW_PATIENT_ID":
      return Object.assign({}, state, action.get());

    case "CLEAR_PATIENT":
    case "LOGOUT":
      return null;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reducers/patient.reducer.ts